/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_A4Inputs */

const en_dr_faq_a4 = /** @type {(inputs: Dr_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cards, votes and the AI summaries stay attached to the workspace that owns the room, the same way a plan's data does — nothing is shared across workspaces.`)
};

const id_dr_faq_a4 = /** @type {(inputs: Dr_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu, suara, dan ringkasan AI tetap melekat pada workspace pemilik ruang, sama seperti data sebuah plan — tidak dibagikan lintas workspace.`)
};

/**
* | output |
* | --- |
* | "Cards, votes and the AI summaries stay attached to the workspace that owns the room, the same way a plan's data does — nothing is shared across workspaces." |
*
* @param {Dr_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_a4 = /** @type {((inputs?: Dr_Faq_A4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_A4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_a4(inputs)
	return en_dr_faq_a4(inputs)
});